import script from "./MeetOurTalent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetOurTalent.vue?vue&type=script&setup=true&lang=ts"

import "./MeetOurTalent.vue?vue&type=style&index=0&id=387300fa&lang=scss"

const __exports__ = script;

export default __exports__